import AddCommitmentsToEqualisation from '../Editor/AddCommitmentsToEqualisation/index';
import PageContent from 'components/PageContent';
import PageContainer from 'components/PageContainer';
import { EqualisationProvider } from '../Editor/EqualisationContext';
import { EqualisationSection } from 'further-types/lp/equalisation';
import { useLayoutContext } from 'contexts/LayoutContext';

const AddEqualisation: React.FC = () => {
  const { vehicle } = useLayoutContext();

  if (!vehicle) return null;

  return (
    <EqualisationProvider
      baseCurrency={vehicle.baseCurrency}
      initialSection={EqualisationSection.Commitments}
      sections={[EqualisationSection.Commitments]}
      commitments={[]}
    >
      <PageContainer heading="Close & Equalise">
        <PageContent withSpacing>
          <AddCommitmentsToEqualisation />
        </PageContent>
      </PageContainer>
    </EqualisationProvider>
  );
};

export default AddEqualisation;
